import React, { Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { gAPI_Stripe_Connection, gAPI_Stripe_Ingetration } from '../../../../constants/APIs';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { RssFeed } from '@material-ui/icons';
class Index extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        var restUrl = window.location.href.substring(window.location.href.lastIndexOf("?") + 6,
            window.location.href.lastIndexOf("&"));
        var state = window.location.href.substring(window.location.href.lastIndexOf("&") + 7,
            window.location.href.length);
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Stripe_Connection}/code?code=${restUrl}`,
        }).then((m) => {

            let inputData = {
                groupId: getGroupID(),
                name: "",
                defaultLanguage: "en-US",
                properties: [
                    state
                ],
                sessionTimeoutInSeconds: 0,
                stripeCustomerId: m.data.stripe_user_id
            }
            AxiosAPI({
                method: 'post',
                url: gAPI_Stripe_Ingetration,
                data: inputData
            }).then((res) => {
                let data = {
                    GroupId: getGroupID(),
                    PropertyId: state,
                    Creator: "Admin",
                    StripeCustomerId: res.data.id,
                    StripeStatus: 'Active'
                };
                AxiosAPI({
                    method: 'post',
                    url: `${gAPI_Stripe_Connection}/save`,
                    data: data
                }).then((res) => {
                    localStorage.setItem("ShowMessage", true);
                    window.location.href = `/app/pages/integration`;
                });
            });
        });
    }

    render() {
        return (
            <Fragment></Fragment>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));